// The admin console's shared state: which instance it manages (client), who
// the caller is there (me) and that instance's catalogue (meta, from
// GET /api/users/meta). Sections read it with useConsole().

import { createContext, useContext } from 'react';

export const ConsoleContext = createContext(null);

export const useConsole = () => useContext(ConsoleContext);

/** Where a user can be routed: registered instances and the env 'remote'. */
export function routingTargets(meta) {
  const list = (meta.instances || []).map((i) => ({ key: i.key, label: i.label, url: i.url, environment: i.environment }));
  if (meta.remote_instance && !list.some((i) => i.key === 'remote')) {
    list.push({ key: 'remote', label: meta.remote_instance.label, url: meta.remote_instance.url, environment: '' });
  }
  return list;
}
